import { Component, OnDestroy, OnInit } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, } from "@angular/forms";
import { AutocompleteLoadingModeType, IAutocompleteSchema, IDatepickerSchema, ToastService } from "maps-angular-components";
import { Subject, Subscription } from "rxjs";

import { MatDialog } from "@angular/material/dialog";
import { Carteira, CarteiraAutocompleteModel } from "../../carteira/carteira.model";
import { CarteiraService } from "../../carteira/carteira.service";
import { MemoriaCalculoComponent } from "../../memoria-calculo/memoria-calculo.component";
import { Regra } from "../../regra/regra";
import { RegraService } from "../../regra/regra.service";
import { BrowserSupport } from "../../shared/util/browser-support";
import { indicate } from "../../shared/util/loading-indicate";
import { ResultadoRegra } from "../resultado-regra";
import { ResultadoRegraService } from "../resultado-regra.service";
import { StatusRegra } from "../resultado-regra/status-regra";
import { TipoExecucao } from "../resultado-regra/tipo-execucao";
import { CarteiraGrupoAutocompleteService } from "src/app/carteira/carteira-grupo-autocomplete.service";

@Component({
    selector: "app-resultado-regra-pesquisa",
    templateUrl: "./resultado-regra-pesquisa.component.html",
    styleUrls: [
        "./resultado-regra-pesquisa.component.scss",
        "../../shared/form-component.css",
    ]
})
export class ResultadoRegraPesquisaComponent implements OnInit, OnDestroy {
    private readonly subscriptions = new Subscription();

    data: ResultadoRegra[] = [];

    form: FormGroup;
    resultadoRegras: ResultadoRegra[] = [];
    paginationTotalPage = 1;
    public totalRegistros = 0;

    status = StatusRegra.getStatusProcessamento;
    tiposExecucao = TipoExecucao.getTiposExecucao;
    expandedElement: ResultadoRegra;

    loading$: Subject<boolean> = new Subject<boolean>();

    loadingExport$: Subject<boolean> = new Subject<boolean>();
    page$: Subject<number> = new Subject<number>();
    private pageSize = 20;

    public carteiraSchema: IAutocompleteSchema<CarteiraAutocompleteModel>;
    public carteiraSchemaChip: IAutocompleteSchema<Carteira>;
    public regraSchema: IAutocompleteSchema<Regra>;
    public dataInicioSchema: IDatepickerSchema;
    public dataFimSchema: IDatepickerSchema;

    constructor(
        private readonly formBuilder: FormBuilder,
        private readonly resultadoRegraService: ResultadoRegraService,
        private readonly carteiraGrupoAutocompleteService: CarteiraGrupoAutocompleteService,
        private readonly regraService: RegraService,
        private readonly carteiraService: CarteiraService,
        private readonly dialog: MatDialog,
        private readonly messageService: ToastService
    ) {

    }

    ngOnInit() {
        this.form = this.formBuilder.group({
            carteiraId: new FormControl(),
            regra: new FormControl(),
            status: new FormControl(),
            tiposExecucao: new FormControl(),
            mensagem: new FormControl(),
            ativaUltimaDataProcessamento : new FormControl(),
            page: new FormControl(0),
        });

        this.page$.subscribe(value => {
            this.form.controls.page.setValue(value - 1);
            this.pesquisar();
        });

        this.carteiraSchema = {
            service: this.carteiraGrupoAutocompleteService,
            label: "",
            placeholder: "",
            loadingMode: AutocompleteLoadingModeType.LAZY,
            autoload: false,
            endpoint: "",
            formGroup: this.form,
            formControlName: "carteiraId",
            panelClass: "large-input",
            parseSearchParam(search): string {
              return search;
            },
          };

        this.carteiraSchemaChip = {
            service: this.carteiraService,
            label: "Carteira (Carteira / Grupo carteira)",
            placeholder: "Nome da carteira",
            loadingMode: AutocompleteLoadingModeType.LAZY,
            required: false,
            autoload: false,
            endpoint: "nome-ou-cnpj",
            formGroup: this.form,
            formControlName: "carteiraChip",
            panelClass: "w-100",
            parseSearchParam(search): string {
                return search;
            },
        };

        this.regraSchema = {
            service: this.regraService,
            endpoint: "autocomplete/associacao/resultado",
            label: "Regra (Regra simples / Regra composta)",
            placeholder: "Regra selecionada",
            loadingMode: AutocompleteLoadingModeType.LAZY,
            required: false,
            autoload: false,
            formGroup: this.form,
            formControlName: "regra",
            panelClass: "w-100",
            parseSearchParam(search): string {
                return search;
            },
        };
        this.dataInicioSchema = {
            label: "Data início vigência",
            placeholder: "Selecione uma data",
            formGroup: this.form,
            required: true,
            panelClass: "w-100",
            formControlName: "dataInicio"
        };

        this.dataFimSchema = {
            label: "Data fim vigência",
            placeholder: "Selecione uma data",
            formGroup: this.form,
            required: true,
            panelClass: "w-100",
            formControlName: "dataFim"
        };
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    pesquisar() {

        this.resultadoRegras = [];
        this.totalRegistros = 0;
        if (this.form.value.ativaUltimaDataProcessamento == null) {
          this.form.controls.ativaUltimaDataProcessamento.setValue(false);
        }
        this.subscriptions.add(
            this.resultadoRegraService
            .search(this.form.value, this.pageSize)
            .pipe(indicate(this.loading$))
            .subscribe(
                (r) => {
                    if (r.metadata.totalElements > 0) {
                        if (r.metadata.size === 0) {
                            this.paginationTotalPage = 1;
                        } else {
                            this.paginationTotalPage = Math.ceil(
                                r.metadata.totalElements / r.metadata.size
                            );
                        }
                        this.totalRegistros = r.metadata.totalElements;
                        this.resultadoRegras = r.content.map(e =>
                            Object.assign(new ResultadoRegra(), e)
                        );
                        this.form.get("page").setValue(r.metadata.number);
                    } else {
                        this.paginationTotalPage = 1;
                    }
                },
                err => {
                    this.messageService.erro(err.error?.message || err.message);
                }
            )
        );
    }

    updatePageSize($event: number): void {
      this.pageSize = $event;
      this.page$.next(1);
    }

    exportarPdf() {
        this.subscriptions.add(
            this.resultadoRegraService.exportPdf(this.form.value).pipe(indicate(this.loadingExport$)).subscribe(data => {
                BrowserSupport.savePDF(data);
            }, err => this.messageService.erro(err.error.message)));
    }

    exportarXls() {
        this.subscriptions.add(
            this.resultadoRegraService.exportXlsx(this.form.value).pipe(indicate(this.loadingExport$)).subscribe(data => {
                BrowserSupport.saveXlsx(data);
            }, err => this.messageService.erro(err.error.message)));
    }

    confirmDialog(r: ResultadoRegra) {
        this.dialog.open(MemoriaCalculoComponent, {
            data: r,
            minWidth: "80vw",
            maxWidth: "80vw",
            maxHeight: "99vh",
            autoFocus: false,
        });
    }

    exportarComposicaoCarteira(id: number) {
      this.subscriptions.add(
          this.resultadoRegraService.exportComposicaoCarteira(id).pipe(indicate(this.loadingExport$)).subscribe(data => {
              BrowserSupport.saveXlsx(data);
          }, err => this.messageService.erro(err.error.message)));
    }

    receiverPage(value) {
        this.page$.next(value);
    }

    rowClicked(r: ResultadoRegra) {
        this.expandedElement = (this.expandedElement === r) ? null : r;
    }

    getTipoExecucao(tipoExecucao: string): string {
        return TipoExecucao.findTiposExecucao(tipoExecucao).name;
    }
}
